import { render, staticRenderFns } from "./Test1.vue?vue&type=template&id=83d8e6ec&scoped=true&lang=pug&"
import script from "./Test1.vue?vue&type=script&lang=ts&"
export * from "./Test1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d8e6ec",
  null
  
)

export default component.exports